export default __webpack_public_path__ + "aa2da5d76a4180363cde48cf93c84d37.png";